export default "__VITE_ASSET__CReZnDme__"